function editProductDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/edit-product/edit-product.html?$$REVISION$$'
  }
}

export { editProductDialog }
